
export enum ShipperLoadedTrailerCd {
	DOCK_DROP = 'DockDrop',
	HOOK_LD = 'HookLd',
	LD_BY_SHPR = 'LdByShpr',
	NOT_LD_BY_SHPR = 'NotLdByShpr'}

